import { registerAction } from '../../Action'

export const MomentActions = {
  FETCH_MOMENTS_REQUEST: 'FETCH_MOMENTS_REQUEST',
  FETCH_MOMENTS_SUCCESS: 'FETCH_MOMENTS_SUCCESS',
  FETCH_MOMENTS_ERROR: 'FETCH_MOMENTS_ERROR',
}
export const getMomentsRequest = registerAction(
  MomentActions.FETCH_MOMENTS_REQUEST,
  {}
)
export const getMomentsSuccess = registerAction(
  MomentActions.FETCH_MOMENTS_SUCCESS,
  {}
)
export const getMomentsError = registerAction(
  MomentActions.FETCH_MOMENTS_ERROR,
  {}
)

export default {
  getMomentsError,
  getMomentsRequest,
  getMomentsSuccess,
}
